module.exports = __webpack_public_path__ + "img/feature_buy_en.f0e966ed.png";